import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

const DropZoneFileUploaderUI = ({ height, infoMessage, error, onDragOver, onDrop }) => (
  <div
    className='drop-zone-file-uploader'
    style={{ height: `${height}px` }}
    onDragOver={onDragOver}
    onDrop={onDrop}
  >
    <div className='drop-zone-file-uploader__drag-zone'></div>
    <p className='drop-zone-file-uploader__info-message'>
      {I18n.t(infoMessage)}
    </p>
    {error && (
      <p className='drop-zone-file-uploader__error-message'>
        {I18n.t(error)}
      </p>
    )}
  </div>
)

export default DropZoneFileUploaderUI
